/* eslint camelcase: off */
import { mapGetters, mapActions } from 'vuex';
import { ROUTES_ENABLE_BIO } from '../constants';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PermissionService } from '@/domains/permission/services/permission-service';

export default {
    data() {
        return {
            anySideSupportBio: false,
            selfPermissions: {},
        };
    },
    computed: {
        ...mapGetters({
            bioSelectedSequences: 'bio/selectedSequences',
            bioSelectedSequencesProcessing: 'bio/querySequencesProcessing',
            isUkLoading: 'bio/isUkLoading',
        }),
        /**
         * bio 高亮按钮是否显示
         */
        bioHlbtnVisibleMixin_visible() {
            const { selfPermissions, isUkLoading } = this;

            const visible = selfPermissions.lifeScience
                && !isUkLoading
                && this.anySideSupportBio;
            /*
             * 用户上一次会话打开了 LifeScience 高亮, 再一次登录系统时, 如果此时用户没有 LifeScience 权限, 程序会 根据 localstorage
             * 存储的高亮标识继续请求 LifeScience 高亮接口.
             * 为了避免上述情况发生, 添加以下代码
             */
            if (!selfPermissions.lifeScience) {
                this['bio/toggle'](false);
            }
            return visible;
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                const path = this.$route.path.replace(/(^\/|\/$)/g, '');
                const tabs = path.split('\'');
                this.anySideSupportBio = (() => {
                    for (let i = 0, size = tabs.length; i < size; i++) {
                        const tab = tabs[i];
                        if (ROUTES_ENABLE_BIO.includes(tab)) {
                            return true;
                        }
                    }
                })();
            },
        },
    },
    methods: {
        ...mapActions([
            'bio/toggle',
        ]),
    },
    created() {
        const permissionService = injectService(PermissionService);
        this.selfPermissions = permissionService.getModelData();
        this.permissionServiceDispose = permissionService.onStatesChange(state => {
            this.selfPermissions = state;
        });
    },
    beforeDestroy() {
        this.permissionServiceDispose?.dispose();
    },
};
